import React from 'react';
import ApAuthScreen from './platform/ApAuthScreen';

export default function SignUp() {
  return <ApAuthScreen mode="sign-up" />;
}
